/*
 * @since: 2020-06-12
 * @author: tams_dev1
*/
import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  url: '/api/vp/ipsec/center',
  interfacesUrl: '/api/vp/ipsec/center/interfaces',
  policyUrl: '/api/vp/ipsec/policies',
  confirmUrl: '/api/vp/command/ipsec-center',

  editDialog: true,
  selectedDevice: {},
  rowSelectItems: [],
  centerConnModel: [],
  axiosModel: {},
  policyModel: {},
  interfacesModel: {},
  bridegeModel: {},
  trunkModel: {},
  interfacesSet: {
    item: '',
    v4_Options: [
      // {
      //   label: 'There is no interfaces',
      //   value: -1
      // }
    ],
    v6_Options: [
      // {
      //   label: 'There is no interfaces',
      //   value: -1
      // }
    ]
  }
})

export const mutations = {
  clearStore: (state) => {
    state.editDialog = true
    state.selectedDevice = {}
    state.rowSelectItems = []
    state.centerConnModel = []
    state.interfacesModel = {}
    state.interfacesSet = {}
  },
  setDialogType (state, data) {
    state.editDialog = data
  },
  deviceInfo: (state, item) => {
    state.selectedDevice = item
  },
  setRowSelectItems (state, data) {
    state.rowSelectItems = data
  },
  getSettingData (state, data) { // 센터 연결 목록 조회
    data = _.map(data, (item) => {
      if (item.ipv4.length > 0) {
        item.ipSelect = item.ipv4
      } else if (item.ipv6.length > 0) {
        item.ipSelect = item.ipv6
      } else {
        item.ipSelect = []
      }
      return item
    })
    state.centerConnModel = _.cloneDeep(data)
  },
  getInterfacesData (state, data) {
    if (data.length === 0) {
      state.interfacesSet.v4_Options = [
        // { label: $t('msg.noInterfaces'), value: -1 }
      ]
      state.interfacesSet.v6_Options = [
        // { label: $t('msg.noInterfaces'), value: -1 }
      ]
      return
    }
    if (_.find(data, ['version', 1]) !== undefined) {
      state.interfacesSet.v4_Options = []
    }
    if (_.find(data, ['version', 2]) !== undefined) {
      state.interfacesSet.v6_Options = []
    }
    if (_.findIndex(data, ['version', 1]) < 0) {
      state.interfacesSet.v4_Options = [
        // { label: $t('msg.noInterfaces'), value: -1 }
      ]
    }
    if (_.findIndex(data, ['version', 2]) < 0) {
      state.interfacesSet.v6_Options = [
        // { label: $t('msg.noInterfaces'), value: -1 }
      ]
    }
    state.interfacesModel = _.cloneDeep(data)
    data.forEach((item) => {
      if (item.version === 1) {
        state.interfacesSet.v4_Options.push({
          label: item.name + '    ' + item.ip,
          value: item.id
        })
      }
      if (item.version === 2) {
        state.interfacesSet.v6_Options.push({
          label: item.name + '    ' + item.ip,
          value: item.id
        })
      }
    })
  },
  addTableList (state, data) { // 센터 연결 추가
    state.centerConnModel.push(data)
  },
  edtTableList: (state, data) => {
    state.centerConnModel = _.map(state.centerConnModel, (item) => {
      if (item.id === state.rowSelectItems[0].id) {
        item = _.cloneDeep(data)
      }
      return item
    })
  },
  getPolicyData (state, data) {
    state.policyModel = _.cloneDeep(data.result)
  }
}

export const actions = {
  // 센터 연결 목록 조회
  async getSettingData ({commit}) { // 센터 연결 목록 조회
    try {
      // 확인 필요?
      // const data = await this.$axios.$get(state.url)
      const data = {
        'code': 'ok',
        'result': [
          {'dev_name': 'Test Device 01', 'auth_prof_id': null, 'rsa_use': 0, 'rsa_id': 'tnt01', 'ldap_attr': 'secuiRemoteUserAttr', 'rad_attr': 25, 'ipv4': [{'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}], 'ipv6': []},
          {'dev_name': 'Test Device 02', 'auth_prof_id': null, 'rsa_use': 1, 'rsa_id': 'sss01', 'ldap_attr': 'secuiRemoteUserAttr', 'rad_attr': 25, 'ipv4': [{'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'orange', 'ip': '119.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}], 'ipv6': []},
          {'dev_name': 'Test Device 03', 'auth_prof_id': null, 'rsa_use': 0, 'rsa_id': 'zzz01', 'ldap_attr': 'secuiRemoteUserAttr', 'rad_attr': 25, 'ipv4': [{'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'dev_name': '', 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}], 'ipv6': []}
        ]
      }
      return resultFactory(commit, {length: null, data: data, action: 'getSettingData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 인터페이스 목록 조회
  async getInterfacesData ({commit}) {
    try {
      const data = {'code': 'ok', 'result': [{'version': 1, 'id': 2, 'name': 'eth0', 'ip': '192.168.40.174/19'}, {'version': 1, 'id': 3, 'name': 'eth1', 'ip': '192.168.40.40/12'}, {'version': 2, 'id': 4, 'name': '6ta1', 'ip': '1::1'}, {'version': 2, 'id': 5, 'name': '6tt2', 'ip': '19:98:98:98:27:99'}]}
      return resultFactory(commit, {length: null, data: data, action: 'getInterfacesData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 센터 연결 추가
  async addTableList ({commit, dispatch, state}, payload) {
    try {
      const data = { 'code': 'ok', 'result': payload }
      return resultFactory(commit, {length: null, data: data, action: 'addTableList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 센터 연결 편집
  async edtTableList ({commit, state, dispatch}, payload) {
    try {
      payload.id = state.rowSelectItems[0].id
      const data = {
        'code': 'ok',
        'result': payload
      }
      return resultFactory(commit, {length: null, data: data, action: 'edtTableList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async getPolicyData ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.policyUrl, {loading: false, successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getPolicyData', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.url}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return false
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
export const getters = {
}

export const strict = false
